module.exports = __webpack_public_path__ + "static/img/3-3.004a794d.png";